import React from 'react'

const Cyber_Security = () => {
  return (
    <div>
        {/* collapseNinetyOne */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingNinetyOne">
                <button
                    className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseNinetyOne"
                    aria-expanded="false"
                    aria-controls="collapseNinetyOne"
                >
                    Introduction To Cybersecurity & Networking
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div
                id="collapseNinetyOne"
                className="accordion-collapse collapse"
                aria-labelledby="headingNinetyOne"
                data-bs-parent="#accordionCourses"
            >
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Goal: Build a strong foundation in cybersecurity principles and network concepts.</strong> <br/><br/>
                    <strong>Cybersecurity Basics</strong>
                    <ul>
                        <li>CIA Triad, Threat Types, Cyber Kill Chain</li>
                        <li>Types of Attacks: Malware, Phishing</li>
                    </ul>
                    <strong>Networking Essentials</strong>
                    <ul>
                        <li>OSI Model, TCP/IP Model</li>
                        <li>IP Addressing, Subnetting, Ports, NAT, DNS </li>
                        <li>Common Protocols: HTTP, HTTPS, FTP, SSH, DNS</li>
                    </ul>
                    <strong>Firewalls and IDS/IPS</strong><br/>
                    <strong>Network Security Best Practices</strong><br/>
                    <strong>Tools & Labs</strong><br/>
                    <ul>
                        <li>Wireshark (Packet Analysis)</li>
                        <li>Nmap (Network Scanning) </li>
                        <li>Burp Suite (Web Proxy Basics) </li>
                        <li>Cisco Packet Tracer (Simulation)</li>
                    </ul>

                </div>
            </div>
        </div>


        {/* collapseNinetyTwo */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingNinetyTwo">
                <button
                    className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseNinetyTwo"
                    aria-expanded="false"
                    aria-controls="collapseNinetyTwo"
                >
                     Linux Essentials + OS & Endpoint Security
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div
                id="collapseNinetyTwo"
                className="accordion-collapse collapse"
                aria-labelledby="headingNinetyTwo"
                data-bs-parent="#accordionCourses"
            >
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Goal: Gain OS-level security knowledge and Linux skills used in cybersecurity. </strong><br/><br/>
                    <strong>Linux Essentials</strong>
                    <ul>
                        <li>File System Structure, Permissions, Sudo</li>
                        <li>Basic Shell Commands, Bash Scripting</li>
                        <li>Package Managers: apt, yum</li>
                        <li>Process & Service Management</li>
                        <li>Networking Commands (netstat, ip, ifconfig, ss) </li>
                    </ul>
                    <strong>OS & Endpoint Security</strong>
                    <ul>
                        <li>Patching and Updates</li>
                        <li>Windows Defender & Group Policies</li>
                        <li>Linux Hardening (SELinux, UFW, Fail2Ban) </li>
                        <li>Antivirus & EDR Tools (e.g. CrowdStrike, Wazuh)</li>
                        <li>USB Security, Encryption, BitLocker</li>
                    </ul>
                    <strong>Tools & Labs</strong>
                    <ul>
                        <li>VirtualBox/Kali Linux/Ubuntu</li>
                        <li>OSSEC / Wazuh</li>
                        <li>ClamAV / Windows Defender</li>
                        <li>Lynis / chkrootkit</li>
                    </ul>
                </div>
            </div>
        </div>


        {/* collapseNinetyThree */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingNinetyThree">
                <button
                    className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseNinetyThree"
                    aria-expanded="false"
                    aria-controls="collapseNinetyThree"
                >
                    Python For Cyber Security
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div
                id="collapseNinetyThree"
                className="accordion-collapse collapse"
                aria-labelledby="headingNinetyThree"
                data-bs-parent="#accordionCourses"
            >
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Goal: Learn scripting for automation, scanning, log analysis, and basic tool development.</strong><br/><br/>
                    <ul>
                        <li>Python Basics: Variables, Lists, Loops, Functions </li>
                        <li>File Handling, Log Parsing, Regex</li>
                        <li>HTTP Requests & Web APIs</li>
                        <li>Scripting Port Scanners and Directory Brute-Forcers</li>
                        <li>Parsing Nmap Output</li>
                        <li>Packet Manipulation (Scapy Basics) </li>
                        <li>Hashing & Cryptography (SHA256, bcrypt)</li>
                        <li>Libraries - os, re, socket, requests, json, hashlib, cryptography, scapy, nmap, paramiko</li>
                        <li>Projects - Port Scanner , Log File Analyzer, Basic Packet Sniffer.</li>
                    </ul>
                </div>
            </div>
        </div>


        {/* collapseNinetyFour */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingNinetyFour">
                <button
                    className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseNinetyFour"
                    aria-expanded="false"
                    aria-controls="collapseNinetyFour"
                >
                    IAM + Security Controls + Cyber Forensics
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div
                id="collapseNinetyFour"
                className="accordion-collapse collapse"
                aria-labelledby="headingNinetyFour"
                data-bs-parent="#accordionCourses"
            >
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Goal: Understand identity, authentication, authorization, and security policy configuration.</strong><br/><br/>
                    <ul>
                        <li>IAM Principles: Authentication vs Authorization</li>
                        <li>RBAC, ABAC, MFA, SSO</li>
                        <li>Azure AD / AWS IAM</li>
                        <li>Privilege Escalation Prevention</li>
                        <li>CIS Benchmarks</li>
                        <li>Password Policies, Hashing</li>
                    </ul>
                    <strong>Tools & Labs</strong>
                    <ul>
                        <li>Azure Portal IAM</li>
                        <li>AWS IAM Console</li>
                        <li>Okta Developer Console</li>
                        <li>Active Directory (Basic Config)</li>
                    </ul>
                </div>
            </div>
        </div>


        {/* collapseNinetyFive */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingNinetyFive">
                <button
                    className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseNinetyFive"
                    aria-expanded="false"
                    aria-controls="collapseNinetyFive"
                >
                    Cyber Forensics Investigation
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div
                id="collapseNinetyFive"
                className="accordion-collapse collapse"
                aria-labelledby="headingNinetyFive"
                data-bs-parent="#accordionCourses"
            >
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Goal: Learn to investigate digital evidence, recover data, and analyze artifacts.</strong><br/><br/>
                    <ul>
                        <li>Types of Forensics: Memory, Disk, Network </li>
                        <li>Imaging Tools & Chain of Custody</li>
                        <li>Log Forensics</li>
                        <li>Timeline Creation & Analysis </li>
                        <li>Windows Registry Analysis</li>
                        <li>Memory Dump Analysis</li>
                    </ul>
                    <strong>Tools & Labs</strong>
                    <ul>
                        <li>Autopsy</li>
                        <li>FTK Imager</li>
                        <li>Volatility</li>
                        <li>Sleuth Kit</li>
                        <li>Redline</li>
                    </ul>
                </div>
            </div>
        </div>


        {/* collapseNinetySix */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingNinetySix">
                <button
                    className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseNinetySix"
                    aria-expanded="false"
                    aria-controls="collapseNinetySix"
                >
                    Mobile App Security + Cloud Security & Compliance
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div
                id="collapseNinetySix"
                className="accordion-collapse collapse"
                aria-labelledby="headingNinetySix"
                data-bs-parent="#accordionCourses"
            >
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Mobile App Security</strong>
                    <ul>
                        <li>Android Architecture & App Fundamentals</li>
                        <li>APK Structure</li>
                        <li>OWASP Mobile Top 10</li>
                        <li>Static Analysis (Code & Manifest File) </li>
                        <li>Dynamic Analysis (Run-time Testing)</li>
                        <li>Reverse Engineering (Apktool, JADX)</li>
                        <li>Frida / Xposed Framework Basics</li>
                    </ul>
                    <strong>Tools & Labs</strong>
                    <ul>
                        <li>MobSF</li>
                        <li>Genymotion Emulator</li>
                        <li>Apktool / jadx</li>
                        <li>Sleuth Kit</li>
                        <li>Frida</li>
                    </ul>
                    <strong>Cloud Security & Compliance</strong>
                    <ul>
                        <li>Shared Responsibility Model</li>
                        <li>IAM Users, Groups, Policies</li>
                        <li>EC2, S3, Security Groups</li>
                        <li>CloudTrail, GuardDuty, Inspector</li>
                        <li>Data Encryption in AWS (KMS, SSE) </li>
                        <li>Compliance: GDPR, ISO 27001, NIST</li>
                    </ul>
                    <strong>Tools & Labs</strong>
                    <ul>
                        <li>AWS Free Tier (EC2, S3, IAM, CloudTrail)</li>
                        <li>AWS CLI</li>
                        <li>AWS Security Hub</li>
                        <li>CloudSploit / ScoutSuite</li>
                    </ul>
                </div>
            </div>
        </div>


        {/* collapseNinetySeven */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingNinetySeven">
                <button
                    className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseNinetySeven"
                    aria-expanded="false"
                    aria-controls="collapseNinetySeven"
                >
                    Cybersecurity In AI Age + Final Project
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div
                id="collapseNinetySeven"
                className="accordion-collapse collapse"
                aria-labelledby="headingNinetySeven"
                data-bs-parent="#accordionCourses"
            >
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Cyber Security in AI Age</strong><br/><br/>
                    <ul>
                        <li>Risks in AI Systems</li>
                        <li>Adversarial Machine Learning</li>
                        <li>Model Poisoning & Data Inference Attacks</li>
                        <li>Deepfakes & AI-Generated Threats</li>
                        <li>AI Model Security Lifecycle</li>
                        <li>Governance & Ethical AI</li>
                    </ul>
                    <strong>Tools & Labs</strong>
                    <ul>
                        <li>TensorFlow (for understanding models)</li>
                        <li>OpenAI GPT Security Concepts</li>
                        <li>Deepfake Detection Tools (Awareness)</li>
                    </ul>
                </div>
            </div>
        </div>


        {/* collapseNinetyEight */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingNinetyEight">
                <button
                    className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseNinetyEight"
                    aria-expanded="false"
                    aria-controls="collapseNinetyEight"
                >
                    Project + Career Readiness
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div
                id="collapseNinetyEight"
                className="accordion-collapse collapse"
                aria-labelledby="headingNinetyEight"
                data-bs-parent="#accordionCourses"
            >
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Final Project</strong>
                    <ul>
                        <li>SOC Simulator with SIEM (Microsoft Sentinel or Splunk)</li>
                        <li>Secure Web App with Threat Modeling</li>
                        <li>Cloud Security Audit (AWS)</li>
                        <li>Mobile App Vulnerability Report</li>
                        <li>Red Team vs Blue Team Scenario</li>
                    </ul>
                    <strong>Threat Modeling</strong>
                    <ul>
                        <li>STRIDE, DREAD Models</li>
                        <li>MITRE ATT&CK Framework</li>
                        <li>Creating Security Use Cases</li>
                    </ul>
                    <strong>Career Prep</strong>
                    <ul>
                        <li>Resume & GitHub Portfolio</li>
                        <li>LinkedIn Optimization</li>
                        <li>Mock Interviews</li>
                        <li>Certification Paths: CEH, CompTIA Security+, OSCP, AZ-500</li>
                    </ul>
                </div>
            </div>
        </div>


        {/* collapseNinetyNine */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingNinetyNine">
                <button
                    className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseNinetyNine"
                    aria-expanded="false"
                    aria-controls="collapseNinetyNine"
                >
                    Bonus Platforms For Hands-On Practice
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div
                id="collapseNinetyNine"
                className="accordion-collapse collapse"
                aria-labelledby="headingNinetyNine"
                data-bs-parent="#accordionCourses"
            >
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Platform</strong>
                    <ul>
                        <li>TryHackMe</li>
                        <li>Hack The Box</li>
                        <li>CyberDefenders</li>
                        <li>OWASP Juice Shop</li>
                        <li>CTFtime</li>
                        <li>Port Swigger</li>
                    </ul>
                    <strong>Focus</strong>
                    <ul>
                        <li>Red/Blue Team Labs</li>
                        <li>CTF, Web, Linux, Forensics</li>
                        <li>SOC Challenges</li>
                        <li>Web Security</li>
                        <li>Community CTFS</li>
                        <li>Web Security Labs</li>
                    </ul>
                </div>
            </div>
        </div>





    </div>
  )
}

export default Cyber_Security